import Store from "store";
import env from "environment";
import { parseTenantFromURL } from "utils";

const CommonURL = {
  getURL: (url, params, configsInput) => {
    let localUrl = url;
    let localParams = params;
    let configs = configsInput || {};
    localParams = localParams || {};
    const domainUrl = "";
    if (domainUrl) {
      localUrl = domainUrl + (localUrl.startsWith("/") ? localUrl : `/${localUrl}`);
    } else if (
      Object.prototype.hasOwnProperty.call(localParams, "domainUrl") ||
      Object.prototype.hasOwnProperty.call(localParams, "domain-url")
    ) {
      localUrl = localParams.domainUrl + localUrl.startsWith("/") ? localUrl : `/${localUrl}`;
      delete localParams.domainUrl;
    } else if (!localUrl.startsWith("http") && !localUrl.startsWith("https")) {
      localUrl = env.REACT_APP_SERVER_API_URL + (localUrl.startsWith("/") ? localUrl : `/${localUrl}`);
    }
    localParams = Object.assign({}, localParams);

    if (!configs) {
      configs = {};
    }

    const headers = configs.headers || {};

    configs = { ...configs, headers };

    const { user: oldAuth, auth } = Store.getState();

    const tenant = parseTenantFromURL(window.location.host);

    configs.headers["X-CashRent-Tenant"] = tenant;

    if (oldAuth.token) configs.headers.Authorization = `Bearer ${oldAuth.token}`;
    if (auth.impersonationTarget) configs.headers["X-CashRent-Author"] = auth.impersonationTarget;

    delete localParams.node;
    return {
      urlProcess: localUrl,
      allParams: localParams,
      configs,
    };
  },
};

export default CommonURL;
